import { createFileRoute, notFound } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// `/manufacturing` stays not found: the pathless `_sidebar` group also matches its folder's path and would draw the sidebar beside nothing.
export const Route = createFileRoute('/_authenticated/manufacturing/')({
    // No access check, as in the catch-all `$.tsx`: the not-found page is for everyone.
    staticData: { access: 'authenticated', chrome: 'home' } satisfies PageStaticData,
    beforeLoad: () => {
        throw notFound();
    },
});
